import { i18n } from "../../globalization/i18n.js";
import * as dom from "../../utils/dom.js";
import { comboBox } from "../rendering/controls-templates-brewed.js";
import { Editor } from "./Editor.js";

export class ComboBox extends Editor {

    constructor(parent, options = {}) {

        super(parent, options);

        const {
            valueContainsItem = false,
            items = [],
            itemValueProp = 'value',
            itemLabelProp = 'label',
            itemDisabledProp = 'disabled',
            itemPositionProp = 'position',
            emptyOptionValue = null,
            emptyOptionLabel = i18n.t('control.combobox.empty_value.select'),
            onGetOptionValue = null,
            onGetOptionLabel = null,
            onGetOptionDisabled = null,
        } = options;

        this.valueContainsItem = valueContainsItem;
        this.items = items;
        this.itemValueProp = itemValueProp;
        this.itemLabelProp = itemLabelProp;
        this.itemDisabledProp = itemDisabledProp;
        this.itemPositionProp = itemPositionProp;
        this.emptyOptionValue = emptyOptionValue;
        this.emptyOptionLabel = emptyOptionLabel;
        this.onGetOptionValue = onGetOptionValue;
        this.onGetOptionLabel = onGetOptionLabel;
        this.onGetOptionDisabled = onGetOptionDisabled;

    };

    getDataValueProp() {

        return (typeof this.dataValueProp === 'function') ? this.dataValueProp.call(this) : this.dataValueProp;

    };

    getDataValue(value) {

        if (this.onGetDataValue && (typeof this.onGetDataValue == 'function'))
            return this.onGetDataValue.call(this, value);
        if (!value)
            return null;
        return value[this.dataValueProp];

    };

    getItems() {

        return (typeof this.items === 'function') ? this.items.call(this) : this.items;

    };

    getOptionValue(item) {

        if (this.onGetOptionValue && (typeof this.onGetOptionValue == 'function'))
            return this.onGetOptionValue.call(this, item);
        if (!item)
            return this.emptyOptionValue;
        return item[this.itemValueProp];

    };

    getOptionLabel(item) {
        if (this.onGetOptionLabel && (typeof this.onGetOptionLabel == 'function'))
            return this.onGetOptionLabel.call(this, item);
        if (!item)
            return this.emptyOptionLabel;
        return item[this.itemLabelProp];

    };

    getOptionDisabled(item) {

        if (this.onGetOptionDisabled && (typeof this.onGetOptionDisabled == 'function'))
            return this.onGetOptionDisabled.call(this, item);
        if (!item)
            return false;
        if (Object.hasOwn(item, this.itemDisabledProp))
            return item[this.itemDisabledProp];
        return false;

    };

    _render(vm) {

        var that = this,
            value = dom.normalizeOptionValue(this.valueContainsItem ? this.getOptionValue(this.getValue()) : this.getValue()),
            items = (this.getItems() || []).map(function (item) {
                var optValue = dom.normalizeOptionValue(that.getOptionValue(item)),
                    optLabel = that.getOptionLabel(item) ?? '?',
                    optDisabled = that.getOptionDisabled(item) || false;
                return {
                    value: optValue,
                    label: optLabel,
                    disabled: optDisabled,
                    data: item
                };
            }),
            css = this.getCss(),
            props = {
                id: this.getId(),
                disabled: this.isDisabled() || this.isReadOnly(),
                onchange: [onValueChange]
            },
            options = {
                visible: this.isVisible(),
                emptyOptionValue: this.emptyOptionValue,
                emptyOptionLabel: this.emptyOptionLabel,
            };

        return comboBox(value, items, css, props, options);

        function onValueChange(e, node) {
            e.preventDefault();
            var value = dom.getSelectValue(e),
                data = dom.getSelectData(e);
            //that.changeValue(value);
            that.changeValue(that.valueContainsItem ? data : value);
        };

    };

}
